import { Controller } from "@hotwired/stimulus"

// Proxy controller that delegates to either "selectize" or "tom-select" controller
// based on the useTomSelect value. It copies data-select-* attributes to the target
// controller's namespace, then replaces itself in data-controller.
//
// Usage:
//   data-controller="select"                              -> uses selectize (default)
//   data-controller="select" data-select-use-tom-select-value="true" -> uses tom-select
export default class extends Controller {
  static values = { useTomSelect: Boolean }

  connect() {
    const target = this.useTomSelectValue ? "tom-select" : "selectize"

    // Copy data-select-* attributes to the target controller's namespace
    for (const { name, value } of [...this.element.attributes]) {
      if (!name.startsWith("data-select-")) continue

      const suffix = name.replace("data-select-", "")
      if (suffix === "use-tom-select-value") continue

      this.element.setAttribute(`data-${target}-${suffix}`, value)
    }

    // Rewrite data-action references from select: to the target controller's namespace
    const action = this.element.getAttribute("data-action")
    if (action) {
      this.element.setAttribute("data-action", action.replaceAll("select:", `${target}:`))
    }

    // Replace this controller with the target controller
    const controllers = this.element.getAttribute("data-controller")
    this.element.setAttribute(
      "data-controller",
      controllers.split(/\s+/).map(c => c === "select" ? target : c).join(" ")
    )
  }
}
